export default {
  computed: {
    $_requiredValidation () {
      return [val => !!val || this.$t('message.common.required')]
    },
    $_zeroValidation () {
      return [val => (val !== null && val !== undefined) || this.$t('message.common.required')]
    },
    $_qtyValidation () {
      return [
        val => !!val || this.$t('message.common.required'),
        val => (val && val > 0) || this.$t('message.common.required')
      ]
    },
    $_multiSelectValidation () {
      return [
        val => !!val || this.$t('message.common.required'),
        val => (val && val.length > 0) || this.$t('message.common.required')
      ]
    },
    $_numberValidation () {
      return [
        val => (val) ? /^[0-9]+$/.test(val) || this.$t('message.common.invalidNumber') : true,
        val => (val) ? !isNaN(this.$format.replaceCommaWithDot(val)) || this.$t('message.common.invalidNumber') : true
      ]
    },
    $_norwegianNumberValidation () {
      return [
        val => (val) ? /^[0-9.,]+$/.test(val) || this.$t('message.common.invalidNumber') : true,
        val => (val) ? !isNaN(this.$format.replaceCommaWithDot(val)) || this.$t('message.common.invalidNumber') : true
      ]
    },
    $_norwegianNumberMinusValidation () {
      return [
        val => (val) ? /^-?[0-9.,]+$/.test(val) || this.$t('message.common.invalidNumber') : true,
        val => (val) ? !isNaN(this.$format.replaceCommaWithDot(val)) || this.$t('message.common.invalidNumber') : true
      ]
    },
    $_emailValidation () {
      return [
        (v) => v ? /^([A-Za-z0-9_\-.+])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,})$/.test(v) || this.$t('message.common.invalidEmail') : true
      ]
    },
    $_discountValidation () {
      return [
        (val) => val ? (this.$format.replaceCommaWithDot(val) <= 100 && this.$format.replaceCommaWithDot(val) >= 0) || this.$t('message.common.invalidNumber') : true
      ]
    },
    $_numberLength () {
      return [
        (val) => val ? (val && val.length <= 4) || this.$t('message.common.maxCharacters', { charCount: 4 }) : true
      ]
    }
  }
}
